<template>
    <div class="cards">
        <img
            data-src="https://images.iphonephotographyschool.com/32307/paypal.svg"
            class="lazy"
            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
            height="26"
            alt="Paypal"
            v-if="isCardSupported('paypal')" />
        <img
            data-src="https://images.iphonephotographyschool.com/32292/visa.svg"
            class="lazy"
            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
            height="26"
            alt="Visa"
            v-if="isCardSupported('visa')" />

        <img
            data-src="https://images.iphonephotographyschool.com/32291/master.svg"
            class="lazy"
            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
            height="26"
            alt="Master_card"
            v-if="isCardSupported('mastercard')" />
        <img
            data-src="https://images.iphonephotographyschool.com/32289/discover.svg"
            class="lazy"
            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
            height="26"
            alt="Discover"
            v-if="isCardSupported('discover')" />
        <img
            data-src="https://images.iphonephotographyschool.com/32288/amex.svg"
            class="lazy"
            src="data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 22'></svg>"
            height="26"
            alt="American Express"
            v-if="isCardSupported('american-express')" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getCardsSupportedByCurrency } from '../constants/currencies';

export default {
    computed: {
        ...mapState(['currency']),
    },
    methods: {
        isCardSupported(card) {
            const cards = getCardsSupportedByCurrency(this.currency);
            return cards[card];
        },
    },
};
</script>
